import { auth } from './firebase';
import { getFirestore, doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { User, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import client from 'apollo-client';
import { gql } from '@apollo/client';

const db = getFirestore();

const GET_USER = gql`
  query GetUser($uid: String!) {
    getUser(uid: $uid) {
      uid
      email
      displayName
    }
  }
`;

const CREATE_USER_PROFILE = gql`
  mutation CreateUserProfile($userInput: UserInput!) {
    createUserProfile(userInput: $userInput) {
      uid
      email
      displayName
      photoURL
      createdAt
    }
  }
`;

export const checkUserExists = async (uid: string) => {
    try {
        const { data } = await client.query({
            query: GET_USER,
            variables: { uid }
        });
        return !!data.getUser;
    } catch (error) {
        console.error('Error checking user existence:', error);
        return false;
    }
};
export const createUserProfileDocument = async (user: User, additionalData?: any) => {
    if (!user) return;

    const { uid, email, displayName, photoURL } = user;

    try {
        // Check if user already exists
        const { data: existingUser } = await client.query({
            query: GET_USER,
            variables: { uid }
        });


        if (existingUser.getUser) {
            console.log('User already exists:', existingUser.getUser);
        } else {
            const { data } = await client.mutate({
                mutation: CREATE_USER_PROFILE,
                variables: {
                    userInput: {
                        uid,
                        email,
                        displayName,
                        photoURL,
                        additionalData
                    }
                }
            });
            console.log('User profile created:', data.createUserProfile);
        }

    } catch (error) {
        console.error('Error creating user profile via GraphQL', error);
    }

};